import { styled } from '@mui/material';
import React from 'react';
import { getEntityImage } from '../../../utils/assetUtils';

const IconGroupContainer = styled('div')({
  '*': {
    mixBlendMode: 'unset !important',
  },
  '.hidden-counts': {
    marginLeft: 7,
    fontWeight: 600,
  },
  '.logos': {
    display: 'flex',
    alignItems: 'center',
  },
  display: 'flex',
  alignItems: 'center',
});

export const RetailerIconGroup = ({
  retailerIds,
  maxSize = 4,
  iconSize = 18,
  buildUnrenderedIconCountString = (hiddenIconCount: number) => `+${hiddenIconCount}`,
}: {
  retailerIds: number[];
  maxSize?: number;
  iconSize?: number;
  buildUnrenderedIconCountString?: (hiddenIconCount: number) => string;
}) => {
  const retailerIdsToRender = retailerIds.slice(0, maxSize);
  const hiddenIconCount = retailerIds.length - maxSize;
  return (
    <IconGroupContainer style={{}}>
      <div
        className="logos"
        style={{
          width: retailerIdsToRender.length * iconSize - iconSize * 0.46 * (retailerIdsToRender.length - 1),
        }}
      >
        {retailerIdsToRender.map((retailerId, index) => {
          const shiftOffset = iconSize * 0.46;
          return (
            <img
              key={`retailer-logo-${retailerId}`}
              src={getEntityImage(retailerId, 'retailer')}
              alt="retailer-logo"
              style={{
                width: iconSize,
                height: iconSize,
                objectFit: 'contain',
                borderRadius: 999,
                fontSize: 10,
                position: 'relative',
                left: -shiftOffset * index,
                zIndex: retailerIdsToRender.length - index,
              }}
            />
          );
        })}
      </div>

      {hiddenIconCount >= 1 ? (
        <div className="hidden-counts" style={{ fontSize: 11 }}>
          {buildUnrenderedIconCountString(hiddenIconCount)}
        </div>
      ) : null}
    </IconGroupContainer>
  );
};
